import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import About from './components/About/About';
import Certifications from './components/Certifications/certs';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <>
      <div className="ocean">
          <svg
            className="waves"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto"
          >
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x={48} y={0} fill="rgba(1,88,113,0.7)" />
              <use xlinkHref="#gentle-wave" x={48} y={3} fill="rgba(1,88,113,0.5)" />
              <use xlinkHref="#gentle-wave" x={48} y={5} fill="rgba(1,88,113,0.3)" />
              <use xlinkHref="#gentle-wave" x={48} y={7} fill="rgb(4, 151, 194)" />
            </g>
          </svg>
      </div >
      <div className="sun">
      </div>
      <nav className="navigation">
        <ul>
          <li><a href="#header">Welcome</a></li>
          <li><a href="#main">About</a></li>
          <li><a href="#certs">Certifications</a></li>
          <li><a href="#projects">Work</a></li>
          <li><a href="#contact">Contact</a></li>
          <li><a href="#footer">Socials</a></li>
        </ul>
      </nav>
      <header id="header">
        <Header />
      </header>
      <main id="main">
        <About />
      </main>
      <section id="certs">
        <Certifications />
      </section>
      <section id="projects">
        <Projects />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <footer id="footer">
        <Footer />
      </footer>
    </>
  );
}

export default App;
